// extracted by mini-css-extract-plugin
export var btnFacebook = "component-module--btn-facebook--83a58";
export var btnLinkedin = "component-module--btn-linkedin--7447a";
export var btnWechat = "component-module--btn-wechat--00d66";
export var btnXing = "component-module--btn-xing--f2ce0";
export var btnYoutube = "component-module--btn-youtube--7d697";
export var container = "component-module--container--2ac39";
export var hintIcon = "component-module--hintIcon--57acf";
export var icon = "component-module--icon--d21cf";
export var iconText = "component-module--icon-text--7f6c4";
export var mail = "component-module--mail--27384";
export var noticeIcon = "component-module--noticeIcon--82db5";
export var phone = "component-module--phone--685b2";
export var printer = "component-module--printer--aa675";
export var textNoticeHintBlock = "component-module--textNoticeHintBlock--e7a73";
export var textNoticeHintHeadline = "component-module--textNoticeHintHeadline--d9abf";